/**
 * @flow
 */

import { Expo, TimelineLite } from "gsap"
import React, { useEffect, useRef } from "react"
import styled from "styled-components"

type Props = {
  onExitStart: Function,
}

const Container = styled.div`
  position: fixed;
  width: calc(100vw + 10px);
  height: 100vh;
  background-color: var(--cashmere);
  left: -5px;
  top: 0;

  display: flex;
  justify-content: center;
  align-items: center;
  .block {
    width: 60px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    overflow: hidden;
    span {
      font-family: "Botanica";
      font-size: 4rem;
      display: inline-block;
      color: var(--teal);
      transform: translate3d(0, 105px, 0);
    }
    .spinner {
      display: flex;
      flex-direction: column;
      span {
        transform: none;
        width: 60px;
        height: 100px;
      }
    }
  }
`

const Splash = ({ onExitStart, ...props }: Props) => {
  const containerEl = useRef(null)
  const yearsEl = useRef(null)

  useEffect(() => {
    const numbers = document.getElementsByClassName("number")
    let tl = new TimelineLite()
    tl.staggerTo(numbers, 1.5, { y: 0, ease: Expo.easeInOut }, 0.15)
      .to(yearsEl.current, 3.0, { y: -900, ease: Expo.easeInOut }, "-=1.0")
      .to(numbers, 1.5, { y: -105, ease: Expo.easeInOut })
      .to(
        containerEl.current,
        2,
        { y: "-100%", ease: Expo.easeInOut, onStart: () => onExitStart(true) },
        "-=1.35"
      )
  }, [onExitStart])

  return (
    <Container ref={containerEl} {...props}>
      <div className="block">
        <span className="number">2</span>
      </div>
      <div className="block">
        <span className="number">0</span>
      </div>
      <div className="block">
        <span className="number">1</span>
      </div>
      <div className="block">
        <span className="number">
          <div className="spinner" ref={yearsEl}>
            <span>0</span>
            <span>1</span>
            <span>2</span>
            <span>3</span>
            <span>4</span>
            <span>5</span>
            <span>6</span>
            <span>7</span>
            <span>8</span>
            <span>9</span>
          </div>
        </span>
      </div>
    </Container>
  )
}

export default Splash

/*

  Notes:

  Time the tiger delay
  Add a timer on "scroll for radness which will trigger the render of the content"

  Initial state within context is false when loaded
  after animation has played then it updates the state
  this will render the rest of the pages from within the index page of home
  - will make it lightweight
  - will make it befoks

  animation,
  adding a simple call back function to our animations

  TweenLite
  .to(element, duration, {
    onStart: onStart -> function to call once started
    onUpdate: onUpdate -> function that is being called whilst the animation is running
    onComplete: onComplete -> function that is called when the animation stops
  })

  have a look at TweenLite from instead of 2

  create timeline variable, tl new TimelineLite()

  animation 1 :
    animating the letters into view
  animation 2 :
    animating the years from 0 -> 9
  animation 3 :
    animating all of the letters out of the view
  animation 4 :
    animating the page out of view

*/
